// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.options-dialog-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  min-height: 0;
}

.options-dialog-sidebar {
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: var(--dialog-padding);
  padding-right: var(--dialog-padding);
  overflow-y: auto;
}

.options-dialog-sidebar-item {
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: var(--font-size-l);
  padding: calc(var(--dialog-padding) / 4) calc(var(--dialog-padding) / 2);
  margin: calc(var(--dialog-padding) / 4) 0;
  border-radius: var(--dialog-border-radius);
  text-align: left;
  width: 100%;
}

.options-dialog-sidebar-item:hover,
.options-dialog-sidebar-item:focus-visible {
  cursor: pointer;
  background-color: var(--light-grey);
  outline: 2px solid var(--border-color);
  outline-offset: 1px;
}

.options-dialog-sidebar-item-selected {
  background-color: var(--light-blue-background-color);
  font-weight: bold;
}

.options-dialog-main {
  width: 80%;
  border-left: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
}

.options-dialog-sidebar,
.options-dialog-main {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/options-dialog/OptionsDialog.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,wEAAwE;EACxE,yCAAyC;EACzC,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,mCAAmC;EACnC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;AACd","sourcesContent":[".options-dialog-container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  min-height: 0;\n}\n\n.options-dialog-sidebar {\n  width: 20%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding-left: var(--dialog-padding);\n  padding-right: var(--dialog-padding);\n  overflow-y: auto;\n}\n\n.options-dialog-sidebar-item {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-size: var(--font-size-l);\n  padding: calc(var(--dialog-padding) / 4) calc(var(--dialog-padding) / 2);\n  margin: calc(var(--dialog-padding) / 4) 0;\n  border-radius: var(--dialog-border-radius);\n  text-align: left;\n  width: 100%;\n}\n\n.options-dialog-sidebar-item:hover,\n.options-dialog-sidebar-item:focus-visible {\n  cursor: pointer;\n  background-color: var(--light-grey);\n  outline: 2px solid var(--border-color);\n  outline-offset: 1px;\n}\n\n.options-dialog-sidebar-item-selected {\n  background-color: var(--light-blue-background-color);\n  font-weight: bold;\n}\n\n.options-dialog-main {\n  width: 80%;\n  border-left: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n}\n\n.options-dialog-sidebar,\n.options-dialog-main {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
